import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { savePDF } from '@progress/kendo-react-pdf';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { getTaxReportData, handleLoader } from '../../../../redux/actions/TaxAction';
import ShowTaxReport from './ShowTaxReport';
import { setCurrencyFormat } from '../../../../utils/helpers';
import {
    tableHeaderDataTax as tableHeaderData
} from '../../helper';

const Tax = ({ dispatch, rtl }) => {

    const location = useLocation();
    const { taxReportData, salesChannelFilterData, isLoading } = useSelector(
        ({ TaxReducer, marketPlaceReducer }) =>
        ({
            taxReportData: TaxReducer.taxReportData,
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            isLoading: TaxReducer.isLoading
        })
    );

    const previousMonthDate = new Date();
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)

    const [dataToShow, setDataToShow] = useState(taxReportData?.modal?.data);
    const [filterData, setFilterData] = useState({});
    const [fromDate, setFromDate] = useState(previousMonthDate);
    const [toDate, setToDate] = useState(new Date());

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
                flag = false
            }
        }

        return flag
    }

    const container = React.useRef(null);
    const exportToPDF = () => {
        // console.log('Hello')
        Notification.newInstance({}, (notification) => {
            notification.notice({
                content: 'PDF loading......',
                duration: 10,
                style: { top: 120, fontWeight: "bold" },
                maxCount: 10
            });
        });
        const dvChartF = document.getElementById('dvChartFilter');
        const dvChartV = document.getElementById('dvChartView');
        dvChartF.style.display = "none";
        dvChartV.style.display = "none";
        const element = container.current || document.body;

        savePDF(element, {
            paperSize: "auto",
            Header: "test",
            margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
            // margin: "2cm",
            // forcePageBreak: ".page-break",
            //   landscape: true,
            //  multiPage: true,
            fileName: `Virtual Bundle Sales Report ${new Date().getFullYear()}`,
        })
        dvChartF.style.display = "block";
        dvChartV.style.display = "block";
    }

    const handleApplyDate = () => {
        const intFromDate = moment(fromDate).format('YYYYMMDD');
        const intToDate = moment(toDate).format('YYYYMMDD');
        if (intToDate > intFromDate) {
            dispatch(handleLoader(true));
            dispatch(getTaxReportData({
                fromdate: moment(fromDate).format('YYYY-MM-DD'),
                todate: moment(toDate).format('YYYY-MM-DD')
            }));
        }
        else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'To Date must be greater than From Date.'
                });
            });
        }
    }

    useEffect(() => {
        dispatch(handleLoader(true));
        dispatch(getTaxReportData({
            fromdate: moment(fromDate).format('YYYY-MM-DD'),
            todate: moment(toDate).format('YYYY-MM-DD')
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setDataToShow(taxReportData?.modal?.data);
    }, [taxReportData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    const dataToShowForDatesSelected = dataToShow?.filter(item => filterBasedOnFilter(item))

    const modalData = dataToShowForDatesSelected?.map(item => ({
        ...item,
        sales: setCurrencyFormat(Number(item.sales).toFixed(2), true),
        taxPaid: setCurrencyFormat(Number(item.taxPaid).toFixed(2), true),
    }));
    return (
        <Container className="dashboard">
            <Row className="compare-months">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">
                                    Tax Report</h5>
                            </div>
                            <Row className="justify-content-space-between align-items-center">
                                <Col sm="3" md="10">
                                    <Row className="align-items-center">
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(fromDate).toDate()}
                                                            showPreviousMonths
                                                            onChange={handleFromDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">To Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(toDate).toDate()}
                                                            onChange={handleToDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="6" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                            {/* <button className="btn btn-sm btn-primary
                                                    apply-date-button" type="button"
                                                    title='Export to pdf' disabled={isLoading}
                                                    onClick={exportToPDF}>
                                                    Export PDF
                                                </button> */}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
                <Card className="pb-3">
                    <CardBody>
                        <div className="top-location"
                            style={{ minHeight: '400' }}>
                            <div >
                                {isLoading ? <div style={{ minHeight: '200px' }}
                                    className="row align-items-center justify-content-center">
                                    <SmallLoader loading={isLoading} />
                                </div>
                                    : <ShowTaxReport
                                        modalData={modalData}
                                        tableHeaderData={tableHeaderData}
                                    />}
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </Container>
    );
};

Tax.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default connect(state => ({
    rtl: state.rtl,
}))(Tax);
